import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  DECREASE_QUANTITY,
  SET_OPCIONES_PRODUCTO,
} from '../actions/cartActions';

const initialState = {
  cart: [],
  opciones: {}, // { [producto_id]: { banda: '', tipo: '' } }
};

// eslint-disable-next-line default-param-last
const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART: {
      const existingProductIndex = state.cart.findIndex(
        (item) => item.product.producto_id === action.payload.product.producto_id,
      );

      if (existingProductIndex >= 0) {
        const updatedCart = [...state.cart];
        const updatedItem = { ...updatedCart[existingProductIndex] };
        updatedItem.quantity += action.payload.quantity;
        updatedCart[existingProductIndex] = updatedItem;
        return { ...state, cart: updatedCart };
      }
      return { ...state, cart: [...state.cart, action.payload] };
    }

    case REMOVE_FROM_CART: {
      const newOpciones = { ...state.opciones };
      delete newOpciones[action.payload.productId];
      return {
        ...state,
        cart: state.cart.filter(
          (item) => item.product.producto_id !== action.payload.productId,
        ),
        opciones: newOpciones,
      };
    }

    case DECREASE_QUANTITY: {
      const decreasedCart = state.cart.map((item) => {
        if (item.product.producto_id === action.payload.productId) {
          return { ...item, quantity: item.quantity - 1 };
        }
        return item;
      });
      const filteredCart = decreasedCart.filter((item) => item.quantity > 0);

      // Remove opciones for products that reached 0
      const removedIds = state.cart
        .filter((item) => item.product.producto_id === action.payload.productId && item.quantity === 1)
        .map((item) => item.product.producto_id);

      const newOpciones = { ...state.opciones };
      removedIds.forEach((id) => { delete newOpciones[id]; });

      return { ...state, cart: filteredCart, opciones: newOpciones };
    }

    case SET_OPCIONES_PRODUCTO: {
      return {
        ...state,
        opciones: {
          ...state.opciones,
          [action.payload.productId]: {
            banda: action.payload.banda,
            tipo: action.payload.tipo,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default cartReducer;
